import React from 'react';
import LinkPoints from 'components/canvas/components/nodes/components/base-node/components/link-points';
import useNodeComponent from 'components/canvas/hooks/use-node-component';
import useFetchSurfaceNodes from 'components/canvas/components/nodes/hooks/use-fetch-surface-nodes';
import { useSurfaceNodeModalsOperations } from 'routes/surface/hooks/use-surface-node-modals-context';
import { animated, useSpring } from '@react-spring/konva';
import Edges from 'components/canvas/components/edges';

export interface NodesProps {
  surface: string;
  navigateToSurface: Function;
}

export const defaultNodeDimensions = {
  general: { width: 200, height: 200 },
  note: { width: 280, height: 205 },
  link: { width: 350, height: 120 },
  document: { width: 192, height: 272 },
  text: { width: 327, height: 119 },
  text_snippet: { width: 327, height: 119 },
  document_snippet: { width: 327, height: 119 },
  protocol: { width: 300, height: 300 },
  sub_surface: { width: 293, height: 165 },
  // questionnaire: { width: 315, height: 182 },
  questionnaire: { width: 435, height: 182 },
};

function Nodes({ navigateToSurface, surface }: NodesProps) {
  const { nodes, loading } = useFetchSurfaceNodes(surface);

  const { showNodeModal } = useSurfaceNodeModalsOperations();

  const Node = useNodeComponent();

  const opacityAnimation = useSpring({
    from: { opacity: 0 },
    to: { opacity: Number(loading === false) },
  });

  // const bg = nodes.filter((n) => n.__typename === 'SurfaceBackgroundNode')

  const bgSort = nodes
    .filter((n) => n.__typename === 'SurfaceBackgroundNode')
    .sort((a, b) => {
      //return a.updatedAt > b.updatedAt
      return new Date(a.updatedAt) - new Date(b.updatedAt);
    });

  const data = nodes.filter((n) => n.__typename !== 'SurfaceBackgroundNode');

  return (
    <animated.Group id="nodes-group" {...opacityAnimation}>
      <>
        {bgSort.map((node) => {
          return (
            <Node
              key={`node-${node.id}`}
              node={node}
              showNodeModal={showNodeModal}
              navigateToSurface={navigateToSurface}
            />
          );
        })}

        <Edges nodes={nodes} />

        {data.map((node) => {
          return (
            <Node
              key={`node-${node.id}`}
              node={node}
              showNodeModal={showNodeModal}
              navigateToSurface={navigateToSurface}
            />
          );
        })}
      </>

      <LinkPoints />
    </animated.Group>
  );
}

export default Nodes;
